import React from 'react';

/**
 * Session AD (Msg #972) — Floating HP pill.
 * Fixed to the bottom-left, shows current HP / max HP for the logged-in user.
 * Pulses red when the user is fainted (HP=0).  Polls /api/user/hp every 5s.
 */
export default function HpPill({ apiBase, userId, room }) {
  const [hp, setHp] = React.useState(null);

  React.useEffect(() => {
    if (!apiBase || !userId) return;
    let cancelled = false;
    const tick = async () => {
      try {
        const r = await fetch(`${apiBase}/user/hp?user_id=${encodeURIComponent(userId)}`);
        if (!r.ok) return;
        const d = await r.json();
        if (!cancelled) setHp(d);
      } catch { /* ignore */ }
    };
    tick();
    const id = setInterval(tick, 5000);
    return () => { cancelled = true; clearInterval(id); };
  }, [apiBase, userId, room]);

  if (!hp) return null;
  const fainted = !!hp.fainted;
  const pct = hp.hp_max ? Math.max(0, Math.min(100, (hp.hp / hp.hp_max) * 100)) : 0;

  return (
    <div
      data-testid="hp-pill"
      style={{
        position: 'fixed', left: 12, bottom: 12, zIndex: 950,
        padding: '6px 12px',
        background: fainted ? '#7a1a1a' : '#f5f5f0',
        color: fainted ? '#fff3d0' : '#1a1a1a',
        border: '1px solid ' + (fainted ? '#3a0a0a' : '#8a8a7a'),
        borderRadius: 20,
        fontFamily: 'Arial, Helvetica, sans-serif',
        fontSize: 12, fontWeight: 'bold',
        boxShadow: '0 4px 14px rgba(0,0,0,0.35)',
        minWidth: 130,
        animation: fainted ? 'hp-pulse 1.2s ease-in-out infinite' : 'none',
        userSelect: 'none',
      }}
      title={fainted
        ? 'FAINTED — /bless with Goddess_Sophetia, or rest in the Church.'
        : `HP ${hp.hp} / ${hp.hp_max}`}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 3 }}>
        <span>{fainted ? '💀 FAINTED' : '❤ HP'}</span>
        <span>{hp.hp} / {hp.hp_max}</span>
      </div>
      <div
        style={{
          height: 5, background: fainted ? '#3a0a0a' : '#c8c8b8',
          borderRadius: 3, overflow: 'hidden',
        }}
      >
        <div
          data-testid="hp-pill-bar"
          style={{
            width: `${pct}%`, height: '100%',
            background: fainted
              ? '#ff4a4a'
              : (pct > 60 ? '#3a8a3a' : pct > 30 ? '#c8a13a' : '#a04040'),
            transition: 'width 400ms ease-in-out, background 400ms ease-in-out',
          }}
        />
      </div>
    </div>
  );
}
